import {Grid, PlusIcon} from '@logistics-frontend/blocks'
import {useMediaQuery} from '@logistics-frontend/blocks/legacy'
import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {Tooltip} from '@logistics-frontend/blocks/lpc/tooltip'
import {Typographyv2 as Typography} from '@logistics-frontend/blocks/v2'
import {useI18n} from '@logistics-frontend/core/i18n'
import React, {useCallback, useState} from 'react'

import {useConfig} from 'src/config'

import {classes} from './AddCardButton.classes'

type AddCardButtonProps = {
  disabled?: boolean
  onClick?: VoidFunction
}

export const AddCardButton: React.FC<AddCardButtonProps> = ({disabled, onClick}) => {
  const t = useI18n()
  const [open, setOpen] = useState(false)
  const matches = useMediaQuery(theme.breakpoints.down('sm'))
  const config = useConfig()
  const handleClick = useCallback(() => {
    if (matches) {
      setOpen(!open)
      // на мобилках leaveDelay пропс не работает, убираю тултип так
      if (!open) {
        setTimeout(() => setOpen(false), 4000)
      }
    }
  }, [open, matches, setOpen])
  const handleClose = useCallback(() => setOpen(false), [setOpen])
  const handleOpen = useCallback(() => setOpen(true), [setOpen])

  const button: JSX.Element = (
    <Grid
      alignItems="center"
      className={classes.addCardButton}
      component="button"
      disabled={disabled}
      justify="flex-start"
      onClick={onClick}
      wrap="nowrap"
      container
    >
      <Grid className={classes.plusIcon}>
        <PlusIcon />
      </Grid>
      <Typography className={classes.buttonText} variant="body2">
        {t('order.form.payment.add_card', 'Добавить карту')}
      </Typography>
    </Grid>
  )

  return (
    <>
      {disabled ? (
        <Tooltip
          disableHoverListener={matches}
          disableTouchListener={matches}
          onClick={handleClick}
          onClose={handleClose}
          onOpen={handleOpen}
          open={open}
          placement={matches ? 'bottom' : 'left'}
          title={
            <>
              <span>{t('order.form.payment.max_card_limit', 'Кажется, привязано максимальное кол-во карт ')}</span>
              <a href={config.passport.cardsURL} rel="noopener noreferrer" target="_blank">
                {t('order.form.payment.in', 'в')}
                &nbsp;
                {t('order.form.payment.your_account', 'вашем аккаунте')}
              </a>
            </>
          }
          arrow
          interactive
        >
          <span className={classes.disabledButtonWrap}>{button}</span>
        </Tooltip>
      ) : (
        button
      )}
    </>
  )
}
